import script from "./DomainModelResultingEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainModelResultingEvents.vue?vue&type=script&setup=true&lang=js"

import "./DomainModelResultingEvents.vue?vue&type=style&index=0&id=3cbd7434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbd7434"]])

export default __exports__